import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const CompanySelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 16px 10px;

  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);

  ${({ theme }) =>
    theme.isError &&
    `
    padding: 15px 9px;
    border: 1px solid var(--color-error);
  `}

  cursor: pointer;
  position: relative;
`;

export const CompanySelectInput = styled.input`
  flex: 1;

  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: normal;

    color: var(--color-data-alumni-background);
  }

  color: var(--color-text);
`;

export const CompanySelectPlaceholder = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const CompanySelectOptionsContainer = styled.div`
  max-height: 200px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  border-radius: 0px 0px 8px 8px;

  background: #ffffff;

  transform: translateY(calc(100% - 4px));

  overflow: auto;
  z-index: 2;

  & > :last-child {
    padding-bottom: 19px;
  }
`;

export const CompanySelectOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 3px 24px 3px 18px;

  &:hover {
    background: #f5f5f5;
  }
`;

interface CompanySelectOptionLabelProps {
  alreadyAdded?: boolean;
}

export const CompanySelectOptionLabel = styled.span<CompanySelectOptionLabelProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: normal;

  color: ${({ alreadyAdded }) => (alreadyAdded ? 'rgba(23, 28, 51, 0.5)' : 'var(--color-text)')};
`;

export const CompanySelectOptionAlreadyAdded = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

// SELECTED COMPANY
export const CompanySelectSelectedCompaniesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;

export const CompanySelectSelectedCompanyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 24px;

  border-radius: 50px;
  background: var(--color-data-company-background);

  & > svg:first-child {
    mix-blend-mode: multiply;
  }

  & > [data-action='remove'] {
    display: none;
  }

  &:hover {
    background: var(--color-data-company-background-hover);
    padding: 8px 6px 8px 24px;

    & > [data-action='remove'] {
      display: flex;
    }
  }
`;

export const CompanySelectSelectedCompanyLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;

  color: var(--color-text);
`;

export const CompanySelectSelectedCompanyRemoveContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;
